var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    transform: "translate(8.2286 13.371) rotate(90) translate(-8.2286 -13.371)",
    d: "m1.6 5.1429h13.257c2.2091 0 4 1.7909 4 4v8.4571c0 2.2091-1.7909 4-4 4h-13.257c-2.2091 0-4-1.7909-4-4v-8.4571c0-2.2091 1.7909-4 4-4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    transform: "translate(10.971 10.629) rotate(90) translate(-10.971 -10.629)",
    d: "m4.3429 2.4h13.257c2.2091 0 4 1.7909 4 4v8.4571c0 2.2091-1.7909 4-4 4h-13.257c-2.2091 0-4-1.7909-4-4v-8.4571c0-2.2091 1.7909-4 4-4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8.2286 13.371) rotate(90) translate(-8.2286 -13.371)",
    d: "m16.114 5.1429c1.5154 0 2.7429 1.2274 2.7429 2.7429v10.971c0 1.5154-1.2274 2.7429-2.7429 2.7429h-15.771c-1.5154 0-2.7429-1.2274-2.7429-2.7429v-10.971c0-1.5154 1.2274-2.7429 2.7429-2.7429h15.771zm0 1.3714h-15.771c-0.75771 0-1.3714 0.61371-1.3714 1.3714v10.971c0 0.75771 0.61371 1.3714 1.3714 1.3714h15.771c0.75771 0 1.3714-0.61371 1.3714-1.3714v-10.971c0-0.75771-0.61371-1.3714-1.3714-1.3714z",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.457 0c1.5154 0 2.7429 1.2274 2.7429 2.7429v15.771c0 1.5154-1.2274 2.7429-2.7429 2.7429v-1.3714c0.75771 0 1.3714-0.61371 1.3714-1.3714v-15.771c0-0.72274-0.55954-1.3152-1.2686-1.368l-0.10286-0.0034286h-10.971c-0.72274 0-1.3152 0.55954-1.368 1.2686l-0.0034286 0.10286h-1.3714c0-1.5154 1.2274-2.7429 2.7429-2.7429h10.971z",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.4286,
    y: 10.971,
    width: 9.6,
    height: 1.3714,
    rx: 0.68571,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.4286,
    y: 14.4,
    width: 9.6,
    height: 1.3714,
    rx: 0.68571,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 3.4286,
    y: 7.5429,
    width: 9.6,
    height: 1.3714,
    rx: 0.68571,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4286,
    y: 17.829,
    width: 6.1714,
    height: 1.3714,
    rx: 0.68571,
    fill: "#E05C55"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.09d3aee62eba3970c021b55691f6b42f.svg";
export { ForwardRef as ReactComponent };